import React from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from '../services/api';
import AppLayout from '../components/AppLayout';
import { routes } from '../lib/routes';

const BLOQUEADO = ['cidadao', 'empresa'];

export default function TecnicoAnalises() {
  const navigate = useNavigate();
  const { data: user } = useQuery('me', () => api.get('/usuarios/me').then((r) => r.data), { retry: false });
  const { data: protocolos = [] } = useQuery('protocolos', () => api.get('/protocolos').then((r) => r.data));
  const emAnalise = protocolos.filter((p) => p.status === 'em_analise' || p.status === 'em_exigencia');

  if (user && BLOQUEADO.includes(user.tipo)) {
    return <Navigate to={routes.dashboard} replace />;
  }

  return (
    <AppLayout
      title="Painel de analises"
      subtitle="Processos em analise tecnica."
      actions={
        <Link to={routes.dashboard} className="sispro-btn sispro-btn--secondary sispro-btn--sm">
          Dashboard
        </Link>
      }
    >
      <div className="panel">
        <h2 className="text-lg font-semibold mb-4 text-[var(--sispro-primary-strong)]">Protocolos em analise</h2>
        <div className="space-y-3">
          {emAnalise.slice(0, 30).map((p) => (
            <div key={p.id} className="p-3 border border-[var(--sispro-border)] rounded-lg flex flex-wrap justify-between items-center gap-2">
              <div>
                <p className="font-mono text-sm font-semibold">{p.numero}</p>
                <p className="text-sm text-[var(--sispro-muted)]">{p.tipo}</p>
              </div>
              <button type="button" className="sispro-btn sispro-btn--primary sispro-btn--sm" onClick={() => navigate(routes.analise(p.id))}>
                Analisar
              </button>
            </div>
          ))}
          {emAnalise.length === 0 ? <p className="sispro-empty py-6">Nenhum protocolo aguardando analise.</p> : null}
        </div>
      </div>
    </AppLayout>
  );
}
